import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import Homelogo from '@mui/icons-material/Home';
import Schoollogo from '@mui/icons-material/School';
import Supplylogo from '@mui/icons-material/LocalShipping';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import SRVadd from '@mui/icons-material/PostAdd';
import Logo from './images/logo.png';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ScrollToTop from './scrollToTop';

import Home from './home';
import Livechat from './livechat';
import Cloud from './cloud';
// import Asset from './asset';
import Pricing from './pricing';
import Login from './login';
import Students from './students';
import Lessonnotes from './lessonnotes';
import Staff from './staff';
import Password from './forgottenpassword';
import SRV from './srv';
import Academics from './academics';
// import Offlinedata from './data.json';
import RealEstateAgentIcon from '@mui/icons-material/Apartment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AssessmentIcon from '@mui/icons-material/Assessment';
import Settings from './settings';
import Classes from './class';
import AssetManagement from './assetmanagement';
import Floatingtab from './floatingtab';
import OnboardingFeeBanner from './components/OnboardingFeeBanner';
import Badge from '@mui/material/Badge';
import CampaignIcon from '@mui/icons-material/Campaign';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import Staffer from '@mui/icons-material/Engineering';
import Student from '@mui/icons-material/Person';
import PaymentsIcon from '@mui/icons-material/Payments';
import Payment from '@mui/icons-material/Payment';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CalculateIcon from '@mui/icons-material/Calculate';
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import StudentAttendanceIcon from "@mui/icons-material/School";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

import ListItemButton from '@mui/material/ListItemButton';

import LogoutIcon from '@mui/icons-material/Logout';

import Collapse from '@mui/material/Collapse';
import DraftsIcon from '@mui/icons-material/Drafts';
import SettingsIcon from '@mui/icons-material/Settings';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Classgroup from '@mui/icons-material/Groups';
import {Offline, Online} from "react-detect-offline";
import MoneyIcon from '@mui/icons-material/Money';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MailIcon from '@mui/icons-material/Mail';
import SellIcon from '@mui/icons-material/Sell'
import { Business as BusinessIcon } from '@mui/icons-material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Person from './images/Ellipse77.png';
import Sislogo from './images/sislogo.png';
import ForumIcon from '@mui/icons-material/Forum';
import GroupIcon from '@mui/icons-material/Group';
import Modifyvehicle from './vehiclemodify';
import Timetable from './timetable';
import Schoolfees from './schoolfees';
import Canteenfees from './canteenfees';
import Miscellaneous from './miscellaneous';
import Salaries from './salaries';
import Expenses from './expenses';
import SalesManagement from "./salesManagement";
import Messages from './messages';
import Circular from './circular';
import Siren from './siren';
import Canteen from './components/app';
import StaffAttendance from './components/StaffAttendance';
import Report from './reportpage';
import Announcement from './announcement';
import VendorPortal from './vendor';
// import { useRoute } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import "./index.css"
import axios from 'axios';
import io from 'socket.io-client';
import Updatehome from './canteenfees';
import {BrowserRouter as Router, Routes, Route, Link, useLocation, HashRouter, Outlet} from "react-router-dom";
import { Alarm, BusAlertOutlined } from '@mui/icons-material';
import {  getchat } from './redux/chat';
import { schooldetails } from './redux/schooldetails';
import { getofflinedata } from './redux/offline';
import { announcement_ } from './redux/announcement';
import { loin, logout, updatestudentdata, getdata } from './redux/students';
import { updateteacherdata, getdatateacher } from './redux/teachers';
import { getdata_ } from './redux/class';
import { hasFinanceFullStudentAccess, hasCanteenCollectorAccess } from './utils/financeStaffRoles';
import { updateexpensesdata, getdataexpenses } from './redux/expenses';
import { styled } from '@mui/material/styles';
import EmojiPicker from 'emoji-picker-react';
import Alarms from "./alarm.wav"
import Playalarms from "./Playalarm"

import './Appalert.css';

// Sound URLs - Using direct URLs from a reliable source
const SOUND_URLS = {
  bell: Alarm,
  siren: 'https://www.soundjay.com/button/button-2.mp3',
  horn: 'https://www.soundjay.com/button/button-3.mp3'
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const drawerWidth = 230;




const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

// Screen Wake Lock functionality
const useWakeLock = () => {
  const [wakeLock, setWakeLock] = useState(null);

  const requestWakeLock = async () => {
    try {
      if ('wakeLock' in navigator) {
        const lock = await navigator.wakeLock.request('screen');
        setWakeLock(lock);
        return true;
      }
    } catch (err) {
      console.error('Wake Lock error:', err);
    }
    return false;
  };

  const releaseWakeLock = async () => {
    if (wakeLock) {
      await wakeLock.release();
      setWakeLock(null);
    }
  };

  return { requestWakeLock, releaseWakeLock };
};



// Countdown Timer Component
const CountdownTimer = ({ targetTime, onTimeUp }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const target = new Date(targetTime);
      const difference = target - now;

      if (difference <= 0) {
        setTimeLeft('Time\'s up!');
        onTimeUp();
        return;
      }

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetTime, onTimeUp]);

  return <span className="countdown">{timeLeft}</span>;
};



// Styled components for responsiveness
const ResponsiveToolbar = styled(Toolbar)(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5),
  },
}));

const SchoolName = styled(Typography)(({ theme }) => ({
  fontWeight: 'bolder',
  color: 'white',
  float: 'left',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
    maxWidth: '50%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const IconContainer = styled(Box)(({ theme }) => ({
  float: 'right',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}));

const ResponsiveIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'rgba(0,0,0,0.1)',
  marginTop: '8px',
  [theme.breakpoints.down('sm')]: {
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
  },
  [theme.breakpoints.up('sm')]: {
    marginRight: theme.spacing(2),
  },
}));




function ResponsiveDrawer(props) {
    const offlinedata = useSelector((state) => state.offline) || []
    const [socket, setSocket] = React.useState(null)

    const dispatch = useDispatch()


    const { window } = props;
    const location = useLocation()
    const [openloader, setopenloader] = React.useState(false);
    const [messager, setmessager] = React.useState("");
    const [stated, setstated] = React.useState("");
    const [opensnack, setOpensnack] = React.useState(false);

    const [onlinecheck, setonlinecheck] = React.useState(true);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [unseen, setunseen] = React.useState(0);
    const [clicked, setclicked] = React.useState(location.pathname);
    const [preload, setpreload] = React.useState(true);
    const [newmessage, setnewmessage] = React.useState([]);
    const [showInactivityWarning, setShowInactivityWarning] = React.useState(false);
    const [countdownSeconds, setCountdownSeconds] = React.useState(60);
    const inactivityTimerRef = React.useRef(null);
    const countdownTimerRef = React.useRef(null);

    // Initialize socket connection only once
    useEffect(() => {
        const newSocket = io.connect("https://servermain.sisrevolution.com");
        setSocket(newSocket);
        
        // Cleanup function
        return () => {
            if (newSocket) {
                newSocket.disconnect();
            }
        };
    }, []);

    // Sync clicked state with current location
    useEffect(() => {
        setclicked(location.pathname);
    }, [location.pathname]);

    const admin = useSelector((state) => state.admin) || {}
    const Offlinedata = useSelector((state) => state.offline) || []
    const shouldUseAutoLogout = [
      "Class Teacher",
      "Class and Subject Teacher",
      "Subject Teacher",
      "Administrator",
      "School Head",
      "Administrator and Teller",
      "Director"
    ].includes(admin.positiondescription)

    const schooldetails_ = useSelector((state) => state.schooldetails) || []
    const message = useSelector((state) => state.chat) || []
    const safeMessage = Array.isArray(message) ? message : []
    const stud = useSelector((state) => state.students) || []
    const classer = useSelector((state) => state.Class_) || []
    const expenses = useSelector((state) => state.expenses)
    const announcement = useSelector((state) => state.announcement_)

    // var Class_ = useSelector((state) => state.Class_)

    const teachers = useSelector((state) => state.teachers)

    // const chats = [message.length!==0 && message.filter(bug=>bug.senderid!==admin.ID)]
   
    const gettingdataexp = async () => {
      await axios.post("https://servermain.sisrevolution.com/api/expenditure/getexpensesdata/",
          {
              schoolID:admin.schoolID

          }).then(res => {

              if (res.status === 200) {

                  dispatch(getdataexpenses({

                      data: res.data

                  }))


              }

          })

  }

    const schooldata= async () => {
        await axios.post("https://servermain.sisrevolution.com/api/schools/getschooldata/",
            {
                schoolID:admin.schoolID
  
            }).then(res => {
  
              console.log(res.data)
                if (res.status === 200) {
  
                    dispatch(schooldetails({
  
                        data: res.data
  
                    }))
  
                    dispatch(getchat({
  
                      data: res.data[0].chat
  
                  }))
  
  
                }
  
            })
  
    }
  
  
    const gettingdatat = async () => {
          await axios.post("https://servermain.sisrevolution.com/api/teachers/getworkersdata/",
              {
  
                status:"Active",
                schoolID:admin.schoolID
  
              }).then(res => {
  
                  if (res.status === 200) {
  
                      dispatch(getdatateacher({
  
                          data: res.data
  
                      }))
  
  
                  }
  
              })
  
      }
  
      
        const gettingdata_ = async () => {
          await axios.post("https://servermain.sisrevolution.com/api/class/getclassdata/",
              {
  
                status:"Active",
                schoolID:admin.schoolID
  
              }).then(res => {
  
                  if (res.status === 200) {
  
                      dispatch(getdata_({
  
                          data: res.data
  
                      }))
  
  
                  }
  
              })
  
      }
  
  
      const gettingdata = async () => {
        setopenloader(true)
        try{
          const response = await axios.post("https://servermain.sisrevolution.com/api/students/getstudentdata/",
              {
                status:"Active",
                schoolID:admin.schoolID
  
              });
        
        if (response.status === 200) {
            dispatch(getdata({
                data: response.data
            }));
        }
    } catch(err) {
        console.error('Error fetching student data:', err);
        handleClicksnack();
        setmessager("Network Error, please check if server is running on localhost:3008");
        setstated("error");
    } finally {
        setopenloader(false); // Always set loader to false
    }
}
   
  
      
    const announcementdata = async () => {
      await axios.post("https://servermain.sisrevolution.com/api/announcement/getannouncement/",
          {
              schoolID:admin.schoolID
  
          }).then(res => {
  
              if (res.status === 200) {
  
                    const rawAnnouncements = Array.isArray(res.data) ? res.data : []
                    const visibleAnnouncements = []
                    for (let i = 0; i < rawAnnouncements.length; i++) {
                      const item = rawAnnouncements[i]
                      if (item?.to === undefined || item?.to === "All") {
                        visibleAnnouncements.push(item)
                      }
                    }
                    dispatch(announcement_({ announcement: visibleAnnouncements }))
  
  
              }
  
          })
  
  }
  

  React.useEffect(() => {
    let isMounted = true;
    const fetchAllData = async () => {
      setopenloader(true);
      try {
        await Promise.allSettled([
          schooldata(),
          gettingdata(),
          gettingdata_(),
          gettingdatat(),
          gettingdataexp(),
          announcementdata()
        ]);
      } finally {
        if (isMounted) setopenloader(false);
      }
    };
    fetchAllData();
    return () => { isMounted = false; };
  }, []);

  const handleClicksnack = () => {
    setOpensnack(true);
};

const handleClosesnack = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setOpensnack(false);
};

const viewer=async(chatter)=>{
  var chating={...chatter}
  // const viewlist = chatter.filter(bug=> bug.seen && bug.seen.length!==0 ? bug.seen.filter(lister=>lister===admin._id).length===0:bug.seen.length===0 )
  const viewlist = chating
      viewlist.seen=[...viewlist.seen,admin._id]
      chating=viewlist

 



  try{
      // Use functional update to avoid dependency on message state
      dispatch(getchat((prevState) => ({
          data: [...(prevState?.data || []), chating]
      })))
      
      await axios.post("https://servermain.sisrevolution.com/api/schools/viewchat/",
          {
              _id: schooldetails_[0]._id,
              data: viewlist,
              userid: admin._id
          }).then(res => {

              // dispatch(getchat({

              //     data: res.data[0].chat

              // }))

          })
      }catch(err){
          console.log(err)
       console.log("error")
      }



}

useEffect(()=>{
        if (socket && admin.schoolID && admin._id) {
            socket.emit("join_room",[admin.schoolID, admin._id])
        }
},[socket, admin.schoolID, admin._id])
    

      var user = useLocation()
useEffect(() => {
  const incoming = Array.isArray(newmessage)
    ? newmessage
    : newmessage && typeof newmessage === "object"
      ? [newmessage]
      : [];
  if (incoming.length === 0) return;

  var currentlocation = user.pathname;

  if (currentlocation !== "#/livechat") {
    incoming.forEach((nm) => {
      const sid = nm?.senderid != null ? String(nm.senderid) : "";
      const isOwn =
        sid === String(admin._id) ||
        (admin.ID != null && sid === String(admin.ID)) ||
        nm?.sender === "School Admin";
      if (!isOwn) {
        dispatch(
          getchat((prevState) => ({
            data: [...(prevState?.data || []), nm],
          }))
        );
      }
    });
  } else {
    incoming.forEach((nm) => viewer(nm));
  }

  setnewmessage([]);
}, [newmessage, user.pathname, admin.ID, admin._id]); 


  useEffect(() => {
    if (!socket) return; // Don't set up listener if socket is not ready
    
    // Set up socket listener
    const handleTeacherMessage = (data) => {
      setnewmessage(data);
    };
    
    socket.on("receive_teachermessage", handleTeacherMessage)
    
    // Cleanup function to remove listener
    return () => {
      socket.off("receive_teachermessage", handleTeacherMessage)
    }
  }, [socket]) 


var Alldata = [["Dashboard", "/", <Homelogo />], ["Students", "/students", <Student />], ["Student Attendance", "/student-attendance", <StudentAttendanceIcon />], ["Staff", "/staff", <Staffer />], ["Staff Attendance", "/staff-attendance", <AccessTimeIcon />], ["Class", "/class", <Classgroup />], ["Siren", "/siren", <Alarm />] ,  ["Announcement / Bulk SMS", "/announcement", <CampaignIcon />], ["Circular Notification", "/circular", <TextSnippetIcon />],["Time Table", "/timetable", <EventAvailableIcon />],["Lesson Notes", "/lessonnotes", <NoteAltIcon />]]

if(admin.positiondescription==="Accountant" || admin.positiondescription==="Finance Officer"){
  Alldata=[['Dashboard', "/", <Homelogo />], ["Students", "/students", <Student />], ['Class', "/class", <Classgroup />],  ['Siren', "/siren", <Alarm />]  ]
}
if(admin.positiondescription==="Administrator" || admin.positiondescription==="School Head"){
  Alldata=[["Dashboard", "/", <Homelogo />], ["Students", "/students", <Student />], ["Student Attendance", "/student-attendance", <StudentAttendanceIcon />], ["Siren", "/siren", <Alarm />] , ["Staff", "/staff", <Staffer />], ["Staff Attendance", "/staff-attendance", <AccessTimeIcon />], ["Class", "/class", <Classgroup />] ,  ["Announcement / Bulk SMS", "/announcement", <CampaignIcon />],["Circular Notification", "/circular", <TextSnippetIcon />],["Time Table", "/timetable", <EventAvailableIcon />],["Lesson Notes", "/lessonnotes", <NoteAltIcon />]]
}
if(admin.positiondescription==="Class Teacher" || admin.positiondescription==="Class and Subject Teacher"|| admin.positiondescription==="Subject Teacher"){
  Alldata=[["Dashboard", "/", <Homelogo />], ["Students", "/students", <Student />], ["Student Attendance", "/student-attendance", <StudentAttendanceIcon />], ["Class", "/class", <Classgroup />] ,["Time Table", "/timetable", <EventAvailableIcon />]]
}
if(admin.positiondescription==="Canteen Collector"){
  Alldata=[['Dashboard', "/", <Homelogo />], ["Students", "/students", <Student />], ["Canteen Fees", "/canteen", <MoneyIcon />]]
}


useEffect(() => {
    if (!Array.isArray(safeMessage)) {
      setunseen(0)
      return
    }
    let unseenCount = 0
    for (let i = 0; i < safeMessage.length; i++) {
      const bug = safeMessage[i]
      const sid = bug?.senderid != null ? String(bug.senderid) : ''
      if (
        sid === String(admin._id) ||
        (admin.ID != null && sid === String(admin.ID))
      ) {
        continue
      }
      const seen = Array.isArray(bug?.seen) ? bug.seen : []
      if (seen.length === 0) {
        unseenCount += 1
        continue
      }
      let hasSeen = false
      for (let j = 0; j < seen.length; j++) {
        if (seen[j] === admin._id) {
          hasSeen = true
          break
        }
      }
      if (!hasSeen) unseenCount += 1
    }
    setunseen(unseenCount)
  }, [safeMessage, admin._id, admin.ID]) 
  


  const syncall=()=>{
  
      if(navigator.onLine===true){ 
      for(var i in offlinedata){
  
          const doer = async () => {
              await axios.post(offlinedata[i].link,
                  offlinedata[i].data).then(res => {
  
                      if (res.status === 200) {
  
                          const sourceOffline = Array.isArray(offlinedata) ? offlinedata : []
                          const main = []
                          for (let k = 0; k < sourceOffline.length; k++) {
                            const item = sourceOffline[k]
                            if (item?.id !== offlinedata[i]?.id) {
                              main.push(item)
                            }
                          }
                       
                          localStorage.setItem("offline", JSON.stringify(main))
  
                          dispatch(getofflinedata({
                  
                              data: main
                  
                          }))
                          handleClicksnack()
                          setmessager("Data syncing successful")
                          setstated("success")

                        } else {
                        
                        handleClicksnack()
          setmessager("error syncing data")
          setstated("error")

                      }
  
                  })
  
          }
  
          doer()
  
      }
  }
  else{
  
                      handleClicksnack()
                      setmessager("Please connetct to the internet ant try again")
                      setstated("error") 
  
  }
  
  
  }

  const forceLogout = () => {
    setopenloader(true)
    localStorage.clear()
    document.location.reload()
  }

  const clearAllIdleTimers = () => {
    if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current)
    if (countdownTimerRef.current) clearInterval(countdownTimerRef.current)
  }

  const startWarningCountdown = () => {
    setShowInactivityWarning(true)
    setCountdownSeconds(60)
    countdownTimerRef.current = setInterval(() => {
      setCountdownSeconds((prev) => {
        if (prev <= 1) {
          clearAllIdleTimers()
          forceLogout()
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  const resetInactivityTimer = () => {
    if (!shouldUseAutoLogout) return
    clearAllIdleTimers()
    setShowInactivityWarning(false)
    // 5min idle + 60s warning countdown = 6 minutes total before auto logout.
    inactivityTimerRef.current = setTimeout(() => {
      startWarningCountdown()
    }, 5 * 60 * 1000)
  }
  
  
  // Use useEffect to handle offline data syncing
  useEffect(() => {
    if(offlinedata.length !== 0 && navigator.onLine === true){
      syncall()
    }
  }, [offlinedata.length, navigator.onLine])

  useEffect(() => {
    if (!shouldUseAutoLogout) return
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"]
    const handleActivity = () => resetInactivityTimer()
    events.forEach((evt) => document.addEventListener(evt, handleActivity, { passive: true }))
    resetInactivityTimer()
    return () => {
      events.forEach((evt) => document.removeEventListener(evt, handleActivity))
      clearAllIdleTimers()
    }
  }, [shouldUseAutoLogout])



    const logout = () => {
      if(Offlinedata.length===0){
        setopenloader(true)
        localStorage.clear()
        document.location.reload();
      }else{

        handleClicksnack()
        setmessager("You cannot sign out at this time, please sync all data to the cloud first")
        setstated("warning")

      }
       
        // window.location.reload()
    }

    const handleDrawerToggle = (e) => {
        setMobileOpen(!mobileOpen);
    };

    const [open, setOpen] = React.useState(!true);

    const handleClick = () => {
      setOpen(!open);
    };

    const drawer = (
        <div   className='scroller2' style={{
            backgroundColor: "white", color: "gray", height:"100%",paddingBottom:40
        }}>

       

            <div style={{ textAlign: "center", position:"sticky", backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)", width:"100%" }}>
              <img src={Sislogo} width="85%" style={{marginBottom:"-20px"}}/>

                <label htmlFor="contained-button-file">
                    <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}


                    >
                        <Avatar 
  style={{ width:100, height:100, border: "solid", borderWidth:"0.5px", borderColor: "#1976d2", marginTop:12 }} 
  alt="Image" 
  src={schooldetails_.length !== 0 ? 'https://thesis1995revolution0268005074.sisrevolution.com/sisrevolution1995/routes/logothumb/'+schooldetails_[0].image : undefined} 
/>

                    </Badge>
                    <div style={{margin:4}}> 
                      <b style={{color:"white"}}> 
                        {admin.lastname && (admin.lastname).toUpperCase() +" "+admin.othernames && (admin.othernames).toUpperCase()} 
                      </b> 
                    </div>
                    <div style={{margin:4}}> 
                      <small style={{color:"white"}}> {admin.schoolID} </small> 
                    </div>

                </label>    

                <br/>
                   </div>
           
        
            <List sx={{ mr: 2, display: { xs: 'block', lg: "block" , md: "block" } }} style={{width:"100%"}}>
                {Alldata.map((text, index) => (
                    <Link 
                      key={`menu-link-${index}`} // Add unique key
                      to={text[1]}  
                      style={{ textDecoration: "none", color:"gray" }}
                    >
                    <ListItem className= {clicked===text[1]?"menulinkclick" : "button"}   key={text[0]} >
                        <ListItemIcon 
                               style={{color: clicked===text[1]? "#1976d2":"gray"}}
                       >

                            {text[2]}
                        </ListItemIcon>
                        <ListItemText primary={text[0]} />
                        </ListItem>
                    </Link>
                ))}
{(hasFinanceFullStudentAccess(admin) || admin.positiondescription==="Administrator and Teller" || admin.positiondescription==="Director" || admin.smsID!==undefined) && !hasCanteenCollectorAccess(admin)?
                <ListItemButton onClick={handleClick}>
        <ListItemIcon>
        <PaymentsIcon  style={{color:"gray"}}/>
        </ListItemIcon>
        <ListItemText primary="Finance" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      :""}

      
                <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>

        <Link to="/schoolfees" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
          <ListItem sx={{ pl: 4 }} className={clicked==="/schoolfees"?"menulinkclick" : "button"}>
            <ListItemIcon>
              <PaymentsIcon style={{color: clicked==="/schoolfees"? "#1976d2":"gray"}} />
            </ListItemIcon>
            <ListItemText primary="Schools Fees" />
          </ListItem> 
          </Link>
        <Link to="/canteen" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
          <ListItem sx={{ pl: 4 }} className={clicked==="/canteen"?"menulinkclick" : "button"}>
            <ListItemIcon>
              <MoneyIcon style={{color: clicked==="/canteen"? "#1976d2":"gray"}} />
            </ListItemIcon>
            <ListItemText primary="Canteen Fees" />
          </ListItem> 
          </Link>
{admin.positiondescription!=="Administrator and Teller"?
<>
          {/* <Link to="/accounts" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
          <ListItem sx={{ pl: 4 }} className={clicked==="/accounts"?"menulinkclick" : "button"} >
            <ListItemIcon>
              <Payment style={{color: clicked==="/accounts"? "#1976d2":"gray"}} />
            </ListItemIcon>
            <ListItemText primary="Accounts" />
          </ListItem> 
          </Link> */}



          <Link to="/salaries" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
            <ListItem sx={{ pl: 4 }} className={clicked==="/salaries"?"menulinkclick" : "button"}>
              <ListItemIcon>
                <AccountBalanceWalletIcon style={{color: clicked==="/salaries"? "#1976d2":"gray"}} />
              </ListItemIcon>
              <ListItemText primary="Salaries" />
            </ListItem> 
            </Link>
            
            <Link to="/expenses" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
            <ListItem sx={{ pl: 4 }} className={clicked==="/expenses"?"menulinkclick" : "button"}>
              <ListItemIcon>
                <CalculateIcon style={{color: clicked==="/expenses"? "#1976d2":"gray"}} />
              </ListItemIcon>
              <ListItemText primary="Expenditure" />
            </ListItem>
            </Link>
            
            <Link to="/sales" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
            <ListItem sx={{ pl: 4 }} className={clicked==="/sales"?"menulinkclick" : "button"}>
              <ListItemIcon>
                <ShoppingCartIcon style={{color: clicked==="/sales"? "#1976d2":"gray"}} />
              </ListItemIcon>
              <ListItemText primary="Sales Management" />
            </ListItem>
            </Link>
                          <Link to="/assetmanagement" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
                    <ListItem sx={{ pl: 4 }} className={clicked==="/assetmanagement"?"menulinkclick" : "button"}>
                        <ListItemIcon>
                            <RealEstateAgentIcon style={{color: clicked==="/assetmanagement"? "#1976d2":"gray"}} />
                        </ListItemIcon>
                        <ListItemText primary="Assets Management" />
                    </ListItem>
                </Link>

                          <Link to="/vendor" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
                    <ListItem sx={{ pl: 4 }} className={clicked==="/vendor"?"menulinkclick" : "button"}>
                        <ListItemIcon>
                            <BusinessIcon style={{color: clicked==="/vendor"? "#1976d2":"gray"}} />
                        </ListItemIcon>
                        <ListItemText primary="shop with us" />
                    </ListItem>
                </Link>

          <Link to="/report" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
           <ListItem sx={{ pl: 4 }} className={clicked==="/report"?"menulinkclick" : "button"}>
            <ListItemIcon>
              <SummarizeIcon style={{color: clicked==="/report"? "#1976d2":"gray"}} />
            </ListItemIcon>
            <ListItemText primary="Reports" />
          </ListItem>
            </Link>

          {/* Add Accounting Reports */}
          <Link to="/accounting" className="menuclick" style={{ textDecoration: "none", color:"gray" }}>
           <ListItem sx={{ pl: 4 }} className={clicked==="/accounting"?"menulinkclick" : "button"}>
            <ListItemIcon>
              <AssessmentIcon style={{color: clicked==="/accounting"? "#1976d2":"gray"}} />
            </ListItemIcon>
            <ListItemText primary="Accounting Reports" />
          </ListItem>
            </Link>
        </>
        :""}

        </List>
      </Collapse>

      <Divider/>
      {admin.positiondescription!=="Administrator and Teller" && admin.positiondescription!=="Class Teacher" && admin.positiondescription!=="Class and Subject Teacher" && admin.positiondescription!=="Subject Teacher"?
      <>
      <Link  to="/settings"   style={{ textDecoration: "none", color:"gray"  }}>
                    <ListItem className={clicked==="/settings" ?"menulinkclick" : "button"}   key="Settings">
                        <ListItemIcon style={{
                                color:"gray"
                        }}>
                            <SettingsIcon style={{color: clicked==="/settings"? "#1976d2":"gray"}} />
                        </ListItemIcon>
                        <ListItemText primary="Settings" />
                        </ListItem>
                    </Link>
             
           
      <Link  to="/pricing"   style={{ textDecoration: "none", color:"gray"  }}>
                    <ListItem className={clicked==="/pricing" ?"menulinkclick" : "button"}   key="Pricing">
                        <ListItemIcon style={{
                                color:"gray"
                        }}>
                            <SellIcon style={{color: clicked==="/pricing"? "#1976d2":"gray"}} />
                        </ListItemIcon>
                        <ListItemText primary="Pricing" />
                        </ListItem>
                    </Link>
             
           </>
:""
}
            
            <Link  to="/"  onClick={()=>logout()} style={{ textDecoration: "none", color:"red"  }}>
                    <ListItem   key="/">
                        <ListItemIcon style={{
                                color:"red"
                        }}>
                            <LogoutIcon/>
                        </ListItemIcon>
                        <ListItemText primary="LogOut" />
                        </ListItem>
                    </Link>
             
            </List>


           
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;


    
    return (
        <Box sx={{ display: 'flex' }} >



<Snackbar open={opensnack} autoHideDuration={8000} onClose={handleClosesnack}>
                <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                    { messager }
                </Alert>
            </Snackbar>
            <Dialog open={showInactivityWarning}>
                <DialogTitle>Inactivity Warning</DialogTitle>
                <DialogContent>
                    You have been inactive. You will be logged out in <b>{countdownSeconds}</b> seconds.
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setShowInactivityWarning(false)
                            resetInactivityTimer()
                        }}
                        variant="contained"
                    >
                        Stay Logged In
                    </Button>
                    <Button
                        color="error"
                        onClick={() => {
                            clearAllIdleTimers()
                            forceLogout()
                        }}
                    >
                        Logout Now
                    </Button>
                </DialogActions>
            </Dialog>

             <Backdrop
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={openloader}
//   onClick={handleClose}
>
  <CircularProgress color="inherit" />
</Backdrop>



            <CssBaseline  />
            <AppBar
                style={{
                    /* Created with https://www.css-gradient.com */
color: "#1976d2", backgroundImage:"linear-gradient(315deg, #17dddd 0%,  #1760d3 74%)" }}
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
            >
                <ResponsiveToolbar>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: { xs: 1, sm: 2 }, display: { sm: 'none' } }}
      >
        <MenuIcon sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem' } }} />
      </IconButton>
      
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SchoolName>
          {schooldetails_.length !== 0 && schooldetails_[0].schoolname && schooldetails_[0].schoolname.toUpperCase()}
        </SchoolName>
        
        <IconContainer>

          {/* <SchoolName style={{marginRight:"30px"}}>
           <div style={{display:""}}> 
            <div>{ "Next Siren:" } </div> 
            <div> <small>Countdown</small><br/>
            <small>type</small></div> 
             
            </div>
          </SchoolName> */}
          <Link to="/cloudsync">
            <Badge badgeContent={Offlinedata.length} color="error">
              <ResponsiveIconButton
                color="inherit"
                aria-label="cloud sync"
                edge="end"
              >
                <CloudSyncIcon sx={{ color: 'white' }} />
              </ResponsiveIconButton>
            </Badge>
          </Link>

          <Link to="/livechat">
            <Badge badgeContent={unseen} color="error">
              <ResponsiveIconButton
                color="inherit"
                aria-label="live chat"
                edge="end"
              >
                <ForumIcon sx={{ color: 'white' }} />
              </ResponsiveIconButton>
            </Badge>
          </Link>

          <Link to="/teacher-messages">
            <ResponsiveIconButton
              color="inherit"
              aria-label="direct and group messaging"
              edge="end"
            >
              <GroupIcon sx={{ color: 'white' }} />
            </ResponsiveIconButton>
          </Link>

          <Link to="/messages">
            {(() => {
              const safeSchoolMessages = Array.isArray(schooldetails_?.[0]?.messages)
                ? schooldetails_[0].messages
                : [];
              return (
            <Badge 
              badgeContent={
                (() => {
                  let unread = 0
                  for (let i = 0; i < safeSchoolMessages.length; i++) {
                    const view = Array.isArray(safeSchoolMessages[i]?.view) ? safeSchoolMessages[i].view : []
                    if (view.length === 0) unread += 1
                  }
                  return unread
                })()
              } 
              color="error"
            >
              <ResponsiveIconButton
                color="inherit"
                aria-label="messages"
                edge="end"
              >
                <MailIcon sx={{ color: 'white' }} />
              </ResponsiveIconButton>
            </Badge>
              );
            })()}
          </Link>
        </IconContainer>
      </Box>
    </ResponsiveToolbar>
            </AppBar>
            <Box
                component="nav"
               
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 }, }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                   
                    sx={{
                        display: { xs: 'block', sm:'block', md:'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                  
                    sx={{
                        display: { xs: 'none', sm: 'block', md:'block',lg:'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
            id="floater"
                component="main"
                sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
            >

                <Toolbar/>

                <ScrollToTop />
              
                <Outlet />

                <OnboardingFeeBanner />

          {location.pathname !== "/siren" &&
          !["Class Teacher", "Class and Subject Teacher", "Subject Teacher"].includes(admin.positiondescription) && (
          <Playalarms/>
          )}

            </Box>
          
        </Box>
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default ResponsiveDrawer;
